module.exports = __webpack_public_path__ + "static/michel-maus-b8a0c666853bf4c01f3da7e9c33825ec.jpg";